module.exports = __webpack_public_path__ + "img/9788963713946.12191473.jpg";